import http from '@/plugins/axios';
const BASEURL = '/custom-review-form-groups';
export default {
  getProductGroupsTable() {
    return http.get(`${BASEURL}/datatables`).then(res => {
      return res.data;
    });
  },
  getSpecifiedGroup(groupId) {
    return http.get(`${BASEURL}/${groupId}`).then(res => res.data);
  },

  getAllShopProducts(search) {
    const params = {
      search,
      //customReviewFormGroups is needed to get info in which group product is.
      //without this flag endpoint would not return info about groups
      customReviewFormGroups: true,
    };
    return http
      .get('/products', {
        params,
      })
      .then(res => {
        return res.data.data.map(product => {
          return {
            ...product,
            isVisible: true,
            isInCustomReviewFromGroup: product.isInCustomReviewFromGroup || {},
          };
        });
      });
  },
  updateGroup({ name, products, customFields, id }) {
    const customFieldsKeys = Object.keys(customFields);
    const fieldKeys = ['placeholder', 'position', 'title'];

    const params = customFieldsKeys.reduce(
      (previous, current) => ({
        ...previous,
        [`${current}_${fieldKeys[0]}`]: customFields[current][`${fieldKeys[0]}`],
        [`${current}_${fieldKeys[1]}`]: customFields[current][`${fieldKeys[1]}`],
        [`${current}_${fieldKeys[2]}`]: customFields[current][`${fieldKeys[2]}`],
      }),
      {
        name,
        products: products.map(({ id }) => ({ id })),
      }
    );
    return http.post(`${BASEURL}/${id}/edit`, params).then(res => {
      return res.data;
    });
  },
  //820 notes: unused variable removed
  getAllGroupsTable: () => {
    const params = {
      // start: rowsPerPage * (page - 1) || 0,
      // length: rowsPerPage,
      // order: sortBy,
      // orderDirection: descending ? 'desc' : 'asc'
      allRecords: true,
    };
    return http.get(`${BASEURL}/datatables`, { params }).then(res => res.data);
  },
  addNewGroup(name) {
    const params = {
      name,
    };
    return http.post(`${BASEURL}/create`, { ...params });
  },
  removeGroup(groupId) {
    return http.post(`${BASEURL}/${groupId}/delete`);
  },
};
